import Vue from 'vue';
import axios from 'axios';
import * as elementsApi from '@/api/artist/elements.js';
import * as uploadsApi from '@/api/artist/uploads.js';

const state = {
  // from query string in url (camelCase)
  query: {
  },
  // filters
  filters: {
  },
  filtersList: [
    'status',
    'exclusive',
    'modelRelease',
    'propertyRelease',
    'category',
    'collection',
    'youtubeContentId',
  ],
  // hasSelectedFilters: false,
  categories: [],
  collections: [],
  uploadFailList: [],
  // mediatypeTabs: [],
  elements: [],
  selectedElementIds: [],
  mediaTypeStats: [],
  tablePreferences: {
    columns: {},
  },
  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 50,
  },
  //
  cancelTokens: {},
};

const getters = {
  keyword: state => _.get(state.query, 'q'),

  filtersList: state => state.filtersList,
  hasSelectedFilters: state => _.size(_.omitBy(state.filters, _.isNil)) > 0,

  categories: state => state.categories,
  categoriesMenu: ({ categories }) => {
    if (!categories.length) return;
    const result = [...categories].splice(0, 5);
    return result;
  },

  collections: state => state.collections,
  collectionsMenu: ({ collections }) => {
    if (!collections.length) return;
    const result = [...collections].splice(0, 5);
    return result;
  },

  hasSelectedElements: state => state.selectedElementIds.length > 0,
  selectedElementIds: state => state.selectedElementIds,

  currentMediaType: state => _.get(state.query, 'mediaType'),
  // mediatypeTabs: state => state.mediatypeTabs,
  // elementsList: state => state.elementsList,

  uploadFailList: state => state.uploadFailList,
  uploadFailCount: ({ uploadFailList }) => uploadFailList.length,
  hasUploadFail: ({ uploadFailList }) => {
    let bool = false;
    if (uploadFailList.length) {
      bool = true;
    }
    return (bool);
  },

  tablePreferences: state => state.tablePreferences,

  perPage: state => state.pagination.perPage,
  currentPage: state => state.pagination.currentPage,
  totalCount: state => state.pagination.totalCount,

  // priceTemplatesList: state => state.priceTemplatesList,
  allElementsCount(state) {
    const all = state.mediaTypeStats.find(x => x.mediaType === 'all');
    return _.get(all, 'count', 0);
  },
};

function refreshCancelToken(state, tokenName) {
  // cancel previous request
  if (_.has(state.cancelTokens, tokenName)) {
    const info = {
      type: 'cancelToken',
      name: `${tokenName}`,
    };
    state.cancelTokens[tokenName].cancel(info);
  }

  // create cancel token
  state.cancelTokens[tokenName] = axios.CancelToken.source();

  return state.cancelTokens[tokenName];
}

function updateStateElements(state, updatedElements) {
  if (!Array.isArray(updatedElements)) {
    return false;
  }

  // if elements is still displayed
  if (state.elements && state.elements.length) {
    updatedElements.forEach((updatedElement) => {
      const index = state.elements.findIndex(x => x.id === updatedElement.id);

      if (index !== -1) {
        // update vuex with published elements
        // set reactive array
        // https://stackoverflow.com/questions/53794155/vue-js-add-or-set-new-data-to-object-in-store
        Vue.set(state.elements, index, { ...state.elements[index], ...updatedElement });
      }
    });
  }
}

const actions = {
  setCurrentPage({ commit }, number) {
    commit('setCurrentPage', number);
  },
  setCurrentMediaType({ commit }, mediaType) {
    commit('setCurrentMediaType', mediaType);
  },
  setElementsCategories({ commit }, list) {
    commit('setElementsCategories', list);
  },
  listElementsCategories({ commit }, params) {
    if (!_.get(params, 'mediaType')) {
      commit('setElementsCategories', []);
      return [];
    }

    const cancelToken = refreshCancelToken(state, 'listElementsCategories');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };

    return elementsApi.listElementsCategories(params, axiosConfig)
      .then((list) => {
        // console.log('listElementsCategories', list);
        commit('setElementsCategories', list);
        return list;
      });
  },
  // listCollections({ commit }, params) {
  //   const cancelToken = refreshCancelToken(state, 'listCollections');
  //   const axiosConfig = {
  //     cancelToken: cancelToken.token,
  //   };
  //   return collectionsApi.listCollections(params, axiosConfig)
  //     .then((list) => {
  //       // console.log('listCollections', list);
  //       commit('setCollections', list);
  //       return list;
  //     });
  // },
  listUploadFail({ commit }, params) {
    // commit('setUploadFailList', []);

    return uploadsApi.listUploadFail(params)
      .then((response) => {
        console.log('listUploadFail', response);
        commit('setUploadFailList', response.data.data);
        commit('setPagination', response.data);
        return response;
      });
  },
  deleteUploadFails({ commit }, ids) {
    console.log('deleteUploadFails action', ids);

    // optimistically remove it from list
    commit('setUploadFailList', state.uploadFailList.filter(x => !ids.includes(x.id)));

    return uploadsApi.deleteUploadFails(ids)
      .then((response) => {
        console.log('deleteUploadFails response', response);

        // const elements = response.data.data;
        // if (_.size(elements)) {
        //   updateStateElements(state, elements);
        // }

        // return response;
      });
  },
  listElements({ commit }, params) {
    commit('setElements', []);
    const cancelToken = refreshCancelToken(state, 'listElements');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };

    return elementsApi.listElements(params, axiosConfig)
      .then((response) => {
        commit('setElements', response.data.data);
        commit('setPagination', response.data);
      });
  },
  getElementsListCount({ commit }, params) {
    const cancelToken = refreshCancelToken(state, 'getElementsListCount');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };
    return elementsApi.getElementsListCount(params, axiosConfig)
      .then((response) => {
        console.log('getElementsListCount', response);
        const result = response.data.data;
        commit('setMediaTypeStats', result);
        // const tabs = [];
        // Object.keys(result).map((key) => {
        //   const tab = result[key];
        //   if (!['all', 'error'].includes(tab.mediaType)) {
        //     tabs.push(tab);
        //   }
        // });
        //
        // console.log('tabs', tabs);
        // commit('setMediatypeTabs', tabs);
        // return tabs;
        return response;
      });
  },
  exportElements({ commit }, params) {
    console.log('exportElements action', commit, params);

    return elementsApi.exportElements(params)
      .then((response) => {
        console.log('exportElements', response);
        return response;
      });
  },
  // eslint-disable-next-line
  regenerateElementsPreviews({ commit }, skus) {
    console.log('regenerateElementsPreviews action', skus);
    return elementsApi.regenerateElementsPreviews(skus)
      .then((response) => {
        console.log('regenerateElementsPreviews', response);
        return response;
      });
  },
  // eslint-disable-next-line
  publishElement({ commit, state }, sku) {
    console.log('publishElements action', sku);
    return elementsApi.publishElement(sku)
      .then((response) => {
        console.log(response);
        return response;
        // update vuex with published elements
        // const elements = response.data.data;
        //
        // updateStateElements(state, elements);
        //
        // return response;
      });
  },
  // eslint-disable-next-line
  publishElements({ commit, state }, skus) {
    console.log('publishElements action', skus);
    return elementsApi.publishElements(skus)
      .then((response) => {
        // update vuex with published elements
        const elements = response.data.data;

        updateStateElements(state, elements);

        return response;
      });
  },
  // eslint-disable-next-line
  unpublishElement({ commit, state }, sku) {
    console.log('publishElements action', sku);
    return elementsApi.unpublishElement(sku)
      .then((response) => {
        console.log(response);
        return response;
        // update vuex with published elements
        // const elements = response.data.data;
        //
        // updateStateElements(state, elements);
        //
        // return response;
      });
  },
  // eslint-disable-next-line
  unpublishElements({ commit, state }, skus) {
    console.log('unpublishElements action', skus);
    return elementsApi.unpublishElements(skus)
      .then((response) => {
        console.log('unpublishElements', response);

        const elements = response.data.data;

        updateStateElements(state, elements);

        return response;
      });
  },
  // eslint-disable-next-line
  deleteElement({ commit, state }, sku) {
    console.log('publishElements action', sku);
    return elementsApi.deleteElement(sku)
      .then((response) => {
        console.log(response);
        return response;
        // update vuex with published elements
        // const elements = response.data.data;
        //
        // updateStateElements(state, elements);
        //
        // return response;
      });
  },
  // eslint-disable-next-line
  deleteElements({ commit, state, dispatch }, skus) {
    console.log('deleteElements action', skus);
    return elementsApi.deleteElements(skus)
      .then((response) => {
        console.log('deleted', response);

        // if (response.status === 204) {
        //   // remove skus from list
        // }
        const elements = response.data.data;

        if (_.size(elements)) {
          updateStateElements(state, elements);

          // refresh count
          dispatch('getElementsListCount');
        }

        return response;
      });
  },
  getPriceTemplates(params) {
    // @toDo refactor to @/store/modules/artist/template
    console.log('dummy', params);
    return elementsApi.getPriceTemplates()
      .then((response) => {
        console.log('getPriceTemplates', response);
        return response;
      });
  },
  getMetadataTemplates() {
    return elementsApi.getMetadataTemplates()
      .then((response) => {
        console.log('getMetadataTemplates', response);
        return response;
      });
  },
  applyPriceTemplate({ state }, { templateId, skus }) {
    return elementsApi.applyTemplate(templateId, skus)
      .then((response) => {
        console.log('getPriceTemplates', response);

        const elements = response.data.data;

        updateStateElements(state, elements);

        return response;
      });
  },
  applyTemplate({ state }, { templateId, skus }) {
    return elementsApi.applyTemplate(templateId, skus)
      .then((response) => {
        console.log('applyTemplate', response);
        const elements = response.data.data;
        updateStateElements(state, elements);
        return response;
      });
  },
  setQuery({ commit }, query) {
    const filters = {};

    if (query.status) {
      filters.status = query.status;
    }

    if (query.exclusive) {
      filters.exclusive = query.exclusive;
    }

    if (query.category) {
      filters.category = query.category;
    }

    if (query.collection) {
      filters.collection = query.collection;
    }

    if (_.has(query, 'youtubeContentId')) {
      filters.youtubeContentId = query.youtubeContentId;
    }

    commit('setFilters', filters);
    commit('setQuery', query);
  },
  setFilters({ commit }, filters) {
    commit('setFilters', filters);
  },
  // setTablePreference({ commit }, preference) {
  //   commit('setTablePreference', preference);
  // },
  getTablePreferences({ commit }) {
    if (typeof (Storage) !== 'undefined') {
      // test using sessionStorage first
      const json = sessionStorage.getItem('artist.elements.table.preferences.columns');
      // check for json before parsing to avoid error
      if (json) {
        const columns = JSON.parse(json);
        // console.log('getTablePreference', preference);
        commit('setTablePreferences', {
          columns: columns,
        });
        // this.$store.dispatch('artistElementList/setTablePreference', preference);
      }
    }
    // commit('getTablePreferences');
  },
  setTablePreferences({ commit }, preferences) {
    commit('setTablePreferences', preferences);
  },
};

const mutations = {
  setUploadFailList(state, list) {
    state.uploadFailList = list;
  },
  setMediaTypeStats(state, stats) {
    state.mediaTypeStats = stats;
  },
  // setMediatypeTabs(state, tabs) {
  //   state.mediatypeTabs = tabs;
  // },
  setElementsCategories(state, list) {
    state.categories = list;
  },
  setCollections(state, list) {
    state.collections = list;
  },
  setSelectedElementIds(state, ids) {
    console.log('setSelectedElementIds', ids, ids.length);
    state.selectedElementIds = ids || [];
  },
  setQuery(state, query) {
    console.log('setQuery', query);
    state.query = query;
  },
  setFilters(state, filters) {
    console.log(filters);
    state.filters = filters;
  },
  setElements(state, data) {
    state.elements = data;
  },
  setCurrentMediaType(state, mediaType) {
    state.currentMediaType = mediaType;
  },
  // pagination
  setCurrentPage(state, number) {
    state.pagination.currentPage = parseInt(number, 10);
  },
  setPerPage(state, number) {
    state.pagination.perPage = parseInt(number, 10);
  },
  setPagination(state, data) {
    state.pagination.currentPage = data.page;
    state.pagination.perPage = data.perPage;
    state.pagination.itemPerPage = data.perPage;
    state.pagination.totalCount = data.totalCount;
    // state.pagination.totalPage = Math.ceil(response.totalCount / response.perPage, 10);
  },
  setTablePreferences(state, preferences) {
    if (typeof (Storage) !== 'undefined') {
      localStorage.removeItem('tablePreference');

      if (_.has(preferences, 'columns')) {
        // test using sessionStorage first
        sessionStorage.setItem('artist.elements.table.preferences.columns', JSON.stringify(preferences.columns));
      }
    }

    const tablePreferences = { ...state.tablePreferences, ...preferences };

    console.log('setTablePreferences', tablePreferences);
    state.tablePreferences = tablePreferences;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
